import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { ProgressContext } from '../Context/progressContext';
import { RequestNextApi } from '../../api/Request';
import { getCookie } from '../../utils/cookieHandle';
import {  Autocomplete, Button, Checkbox, InputLabel, ListItemIcon, ListItemText, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@mui/material';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
import { useContext } from 'react';
import { Textarea } from '@mantine/core';



export default function NotificationView(props) {
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const[formErrors, setFormErrors] = useState([]);
    const[groupType, setGroupType] = useState(['Conference Attendees','KA Staff','Current KA Members']);
    const router = useRouter();
    const[notification, setNotification] = useState({
        title:'',
        message:'',
        startDate: "",
        startTime:"",
        group:''
    });
    const { view } = props;

    useEffect(() => {
        if (view == 'edit') {
            console.log(props.pid);
            getNotification();
        }
    }, []);

    const getNotification = async () => {
        updateProgress({ isLoading: true });
        try {
            var requestParams = {
                jwtToken: getCookie('jwt-token'),
                id : props.pid
            };
            const res = await RequestNextApi.post('/notifications/get-notification',
                requestParams
            );
            if (res.data.success) {
                var response = res.data.notification[0];
                setNotification({
                    id: response.id,
                    title:response.title,
                    message:response.message,
                    startDate: new Date(response.event_date.date).toISOString().split("T")[0],
                    startTime: new Date(response.event_date.date).toLocaleTimeString('en-US', { hour12: false, hour: 'numeric', minute: 'numeric' }),
                    group: response.group
                });
            } else {
                ShowNotification.error(res.data.message);
            }
        } catch (error) {
            updateProgress({ isLoading: false });
            ShowNotification.error('Error while fetching notification.');
        }
        updateProgress({ isLoading: false });
    }


    const handleSelection =(elementName, e)=>{
        if(elementName == 'title'){
            setNotification({
                ...notification,
                title: e.target.value
            });
        }
        if(elementName == 'message'){
            setNotification({
                ...notification,
                message: e.target.value
            });
        }
        
        if(elementName == 'start_date'){
            setNotification({
                ...notification,
                startDate: e.target.value
            });
        }
        if(elementName == 'start_time'){
            setNotification({
                ...notification,
                startTime: e.target.value
            });
        }        
        if(elementName == 'group'){
            setNotification({
                ...notification,
                group: e.target.value
            });
        }
    }
    const validateForm = ()=>{
        let errorObj = [];
        var formValidation = false;
        if(notification.title == ""){
            formValidation = true;
            errorObj.push("title");
        }
        if(notification.message == ""){
            formValidation = true;
            errorObj.push("message");
        }
        if(notification.startDate == ''){
            formValidation = true;
            errorObj.push("startDate");
        }
        if(notification.startTime == ''){
            formValidation = true;
            errorObj.push("startTime");
        }
        if(notification.group == ''){
            formValidation = true;
            errorObj.push("group");
        }
        setFormErrors(errorObj);
        return formValidation;

    }

    const handleClick = ()=>{
        if(!validateForm()){
            createNotification();
        }else{
            ShowNotification.error('Fields are missing');
        }
    }
    const createNotification = async () => {
        updateProgress({ isLoading: true });
        try {
            var requestParams = {
                jwtToken: getCookie('jwt-token'),
                title: notification.title,
                message: notification.message,
                event_date: notification.startDate + " " + notification.startTime,
                group: notification.group
            };
            if (props.pid) {
                requestParams = {
                jwtToken: getCookie('jwt-token'),
                title: notification.title,
                message: notification.message,
                event_date: notification.startDate + " " + notification.startTime,
                group: notification.group,
                id : props.pid
                };
                console.log("requestParams: ", requestParams)
            }
            const res = await RequestNextApi.post('/notifications/save-notification',
                requestParams
            );
            if (res.data.success) {
                ShowNotification.success(res.data.message);
                router.push(`/staff/notification`);
            } else {
                ShowNotification.error(res.data.message);
            }
        } catch (error) {
            updateProgress({ isLoading: false });
            ShowNotification.error('Error while creating notification.');
        }
        updateProgress({ isLoading: false });
    }

    return (
        <div>
        <div className='mx-auto max-w-6xl px-6 lg:px-8 mt-11'>
            <div className='grid grid-cols-1 lg:grid-cols-1 gap-4 mt-8'>
                <div>Notification Title</div>
                <TextField 
                        color="third" 
                        size="small" 
                        fullWidth 
                        id="notificationTitle"
                        name="notificationTitle"
                        value = {notification.title}
                        onChange={(e)=>handleSelection("title",e)}
                        required
                        error={formErrors.includes("title")}
                    />
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-1 gap-4 mt-8'>
                <div>Message</div>
                <Textarea 
                        color="third" 
                        size="small" 
                        fullWidth 
                        value = {notification.message}
                        id="message"
                        name="message"
                        onChange={(e)=>handleSelection("message",e)}
                        required
                        error={formErrors.includes("message")}
                    />
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4 mt-8'>
                <div>
                    <InputLabel id="demo-simple-select-disabled-label" color='third'>Notification Time</InputLabel>
                    <div className='grid grid-cols-2 lg:grid-cols-2 gap-4'>
                        <TextField
                                fullWidth
                                size='small'
                                type='date'
                                id="start_date"
                                name="start_date"
                                placeholder=""
                                required
                                onChange={(e)=>handleSelection("start_date",e)}
                                value={notification.startDate}
                                error={formErrors.includes("startDate")}
                                />
                            <TextField
                                fullWidth
                                size='small'
                                type='time'
                                id="start_time"
                                name="start_time"
                                placeholder=""
                                required
                                onChange={(e)=>handleSelection("start_time",e)}
                                value={notification.startTime}
                                error={formErrors.includes("startTime")}
                                />
                        </div>
                </div>
                <div>
                    <InputLabel id="demo-simple-select-disabled-label" color='third'>Group</InputLabel>
                    <TextField
                    size='small'
                    fullWidth 
                    id="group"
                    name="group"
                    placeholder=""
                    select
                    required
                    onChange={(e)=>handleSelection("group",e)}
                    error={formErrors.includes("group")}
                    value={notification.group}
                    >
                        {groupType?.map((itr,index) => (
                        <MenuItem key={index} value={itr}>
                            {itr}
                        </MenuItem>
                        ))} 
                    </TextField>
                    
                </div>                
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-1 gap-4 mt-8 mb-8'>
                {   props.pid ?(
                    notification?.id ?
                <div className='text-end space-x-3'>
                <Button 
                    variant="contained" 
                    className='bg-teal-400 hover:bg-teal-400 h-fit'
                    onClick={handleClick}
                    >
                    Edit Notification
                </Button>
            </div>:<div></div>):<div>
                    <Button 
                        variant="contained" 
                        className='bg-teal-400 hover:bg-teal-400 h-fit'
                        onClick={handleClick}
                        >
                        Create Notification
                    </Button>
                </div>

                }
                
            </div>
        </div>
    </div>
    )


}